import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";

const ContactHyfye = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "", ip: "" });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch user IP address
  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(data => setFormData(prev => ({ ...prev, ip: data.ip })))
      .catch(err => console.error("IP fetch error:", err));
  }, []);

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
    setErrors({});
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name || formData.name.length < 2) newErrors.name = "Name must be at least 2 characters.";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email address.";
    if (!formData.message || formData.message.length < 10) newErrors.message = "Message must be at least 10 characters.";
    return newErrors;
  };

  const canSendMessage = () => {
    const history = JSON.parse(localStorage.getItem("messageHistory")) || [];
    const last24h = history.filter(time => (Date.now() - time) < 24 * 60 * 60 * 1000);
    return last24h.length < 2;
  };

  const saveMessageTime = () => {
    const history = JSON.parse(localStorage.getItem("messageHistory")) || [];
    history.push(Date.now());
    localStorage.setItem("messageHistory", JSON.stringify(history));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }
    if (!canSendMessage()) {
      setErrors({ form: "Limit reached: Only 2 messages allowed within 24 hours." });
      return;
    }

    setLoading(true);
    emailjs.send(
      'service_ydye44t',
      'template_0pb0zxl',
      formData,
      'bbyhLoWPPB3KKhvFO'
    )
    .then(() => {
      setSuccessMessage("✅ Message sent successfully! We'll get back to you soon.");
      setFormData({ name: "", email: "", message: "", ip: formData.ip });
      saveMessageTime();
    })
    .catch(() => {
      setErrors({ form: "Something went wrong. Please try again later." });
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <section id="contact" className="contact_section small_pt">
      <div className="container">
        <div className="row">

          {/* Left Side - Contact Info */}
          <div className="col-lg-6 col-md-12 pr-0 res_md_pr_15">
            <div className="bg_light_dark_blue contact_box">
              <div className="title_default_light title_border">
                <h4>Get in Touch</h4>
                <p>Have questions, ideas, or just want to say hi? We'd love to hear from you!</p>
              </div>
              <ul className="list_none contact_info mt-margin">
                <li>
                  <i className="ion-ios-location"></i>
                  <div>
                    <span style={{ color: "#fff", fontWeight: "bold" }}>Location</span>
                    <p style={{ color: "#fff" }}>Toronto, Ontario, Canada</p>
                  </div>
                </li>
                <li>
                  <i className="ion-ios-email"></i>
                  <div>
                    <span style={{ color: "#fff", fontWeight: "bold" }}>Email</span>
                    <p style={{ color: "#fff" }}>hi@hyfye.com</p>
                  </div>
                </li>
              </ul>
              <div className="contct_follow mt-3">
                <span className="text-uppercase" style={{ color: "#fff" }}>Follow Us</span>
                <ul className="list_none social_icon">
                  <li>
                    <a href="https://x.com/hyfyetoken" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="col-lg-6 col-md-12 pl-0 res_md_pl_15">
            <div className="bg_light_dark contact_box">
              <div className="title_default_light title_border">
                <h4>Send Us a Message</h4>
              </div>
              <form onSubmit={handleSubmit} className="form_field">
                <div className="row">

                  {/* Name */}
                  <div className="form-group col-md-12">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name *"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    {errors.name && <p style={{ color: "red", marginBottom: "0" }}>{errors.name}</p>}
                  </div>

                  {/* Email */}
                  <div className="form-group col-md-12">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email *"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    {errors.email && <p style={{ color: "red", marginBottom: "0" }}>{errors.email}</p>}
                  </div>

                  {/* Message */}
                  <div className="form-group col-md-12">
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Your Message *"
                      value={formData.message}
                      onChange={handleChange}
                      rows="4"
                      required
                    ></textarea>
                    {errors.message && <p style={{ color: "red", marginBottom: "0" }}>{errors.message}</p>}
                  </div>

                  {/* Hidden IP Field */}
                  <input type="hidden" name="ip" value={formData.ip} />

                  {/* Submit Button */}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-default" disabled={loading}>
                      {loading ? "Sending..." : "Submit"} <i className="ion-ios-arrow-thin-right"></i>
                    </button>
                  </div>

                  {/* Status Message */}
                  <div className="col-md-12 text-center">
                    {errors.form && <p style={{ color: "red" }}>{errors.form}</p>}
                    {successMessage && <p style={{ color: "lightgreen" }}>{successMessage}</p>}
                  </div>

                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactHyfye;
